
import Clarity from '@microsoft/clarity';
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import { api } from "../../../utils/api";
import { LoginHelper } from "../../../utils/LoginHelper";
import EditorPageLayout from "../../common/editor/EditorPageLayout";
import Form from "./form/Form";

export default function WebinarEdit() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop, setIsDesktop] = useState(() => window.innerWidth > 768);
	const params = useParams();
	const webinarId = params.webinarId;
	const [webinar, setWebinar] = useState(null);
	const [errorMessage, setErrorMessage] = useState('');
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const onResize = () => setIsDesktop(window.innerWidth > 768);
		window.addEventListener("resize", onResize);
		return () => window.removeEventListener("resize", onResize);
	}, []);

	useEffect(() => {
		setIsLoading(true);
		api.webinarFetchEdit({
			token: LoginHelper.getToken(),
			webinar_id: webinarId,
		}).then((result) => {
			setWebinar(result);
			setIsLoading(false);
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}, [webinarId]);

	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'وبینارها', href: '/webinar_list/' },
		{ label: 'ویرایش وبینار' },
	];

	return (
		<EditorPageLayout
			isDesktop={isDesktop}
			pageTitle="ویرایش وبینار"
			metaDescription="ویرایش وبینار در همراهتیم"
			breadcrumbLinks={linkDataList}
			isLoading={isLoading}
			loadError={errorMessage && !webinar ? errorMessage : ""}
		>
			{webinar && <Form webinar={webinar} isDesktop={isDesktop} />}
		</EditorPageLayout>
	);
}
